import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FormSelect from "core/gd-form/form-element/select-new/select-new"

export default function CustomFieldScale(props) {

    const ratingTypeOptions = [
        { label: "3 Stars",   value: 3 },
        { label: "5 Stars",   value: 5 },
    ];

    return (
        <FormRowFlex label="Scale">
            <FormSelect form={props.form}
                        name="ratingType"
                        options={ratingTypeOptions}
                        placeholder="View" />
            <FormError form={props.form} name="ratingType" />
        </FormRowFlex>
    );
}

CustomFieldScale.propTypes = {
    form: PropTypes.object
}